import axios from 'axios';
import apiClient from '../api/axios';
import { API_ENDPOINTS } from '../api/endpoints';
import { getRefreshToken } from '../utils/authCookies';

const authClient = axios.create({
  baseURL: 'https://dev-api.ufuqmiayar.com/api/v1',
  withCredentials: true,
});

export interface LoginPayload {
  username: string;
  password: string;
}

export interface AuthResponse {
  tokenType: string;
  accessToken: string;
  accessTokenExpiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
  username: string;
  authorities: string[];
  mustChangePassword: boolean;
}

export const loginUser = async (payload: LoginPayload) => {
  const response = await apiClient.post(API_ENDPOINTS.LOGIN, payload);

  return response.data as AuthResponse;
};

export const logoutUser = async () => {
  const response = await apiClient.post(API_ENDPOINTS.LOGOUT, {
    refreshToken: getRefreshToken(),
  });

  return response.data;
};

export const refreshToken = async (refreshToken: string) => {
  const response = await authClient.post(API_ENDPOINTS.REFRESH, {
    refreshToken,
  });

  return response.data as AuthResponse;
};
